// NPM Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Tooltip } from "../../../revvComponents";

// Component Imports
import AddProductColumn from "../../Products/AddProductColumn";
import AgGridVisibilityCtrl from "../../AgGridVisibilityCtrl";

// Actions Imports
import ProductActions from "../../../actions/ProductActions";

// Internal Imports
import { PERMISSIONS, GRID } from "../../../constants";
import withRbac from "../../../app/withRbac";

// Destructuring
const { togglePopUp } = ProductActions;
const { GRID_PAGE_TYPE } = GRID;
class ProductsBar extends Component {
  state = {
    showAddProductModal: false,
    showManageColumnModal: false,
  };

  _togglePopUp = flag => {
    this.props.togglePopUp(flag);
  };

  _toggleModals = key => {
    this.setState(prevState => ({
      [key]: !prevState[key],
    }));
  };

  _toggleManageColumnModal = (flag, value) => {
    this.setState({
      [flag]: value,
    });
  };

  render() {
    const { filterTxt, onFilterChange } = this.props;
    const AddProductBtn = withRbac(() => (
      <Button
        type="four"
        className="productsbar-additem"
        id="productsbar-additem"
        data-testid="productsbar-additem"
        onClick={() => this._togglePopUp(true)}
        data-test="productbar-add-new-product-btn">
        Add new product
      </Button>
    ));
    return (
      <div className="productsbar-wrapper">
        <div className="productsbar-search">
          <i className="productsbar-searchicon">
            <FontAwesomeIcon icon={["far", "search"]} />
          </i>
          <Input
            className="productsbar-input"
            placeholder="Search products"
            value={filterTxt}
            onChange={onFilterChange}
            data-test="productbar-filtertxt-input"
          />
          <Tooltip placement="top" overlay="Add New Column to the Product">
            <Button
              className="productsbar-addcolumn"
              type="six"
              onClick={() => this.setState({ showAddProductModal: true })}
              data-test="product-add-column-btn">
              <i>
                <FontAwesomeIcon icon={["far", "table"]} />
              </i>
              Add Column
            </Button>
          </Tooltip>
          <Tooltip
            placement="top"
            overlay="Manage visibility of the columns based on roles">
            <Button
              className="productsbar-managecolumn"
              type="six"
              onClick={() => this._toggleModals("showManageColumnModal")}
              data-test="product-add-column-btn">
              <i>
                <FontAwesomeIcon icon={["far", "eye"]} />
              </i>
              Hide/view columns
            </Button>
          </Tooltip>
        </div>
        <AddProductBtn permission={PERMISSIONS.PRODUCTS.CREATE_PRODUCTS} />

        {this.state.showAddProductModal && (
          <AddProductColumn
            onClose={() => this._toggleModals("showAddProductModal")}
          />
        )}

        {this.state.showManageColumnModal && (
          <Modal
            open
            onClose={() => this._toggleModals("showManageColumnModal")}
            closeOnOverlayClick={false}
            center>
            <AgGridVisibilityCtrl
              page={GRID_PAGE_TYPE.PRODUCTS}
              title="Manage columns visibility"
              togglePopUp={() => this._toggleModals("showManageColumnModal")}
            />
          </Modal>
        )}
      </div>
    );
  }
}

ProductsBar.propTypes = {
  // Actions
  togglePopUp: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  togglePopUp,
};

export default connect(null, mapDispatchToProps)(ProductsBar);
